// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pp-files .btn-add{background:#f5f5f5 !important}.theme-bg .pp-files .btn-add{background:#28282d !important}.file-item .btn-remove-file{display:none}.file-item:hover .btn-remove-file{display:inline-block}.cropper-line,.cropper-point{background:#fff !important}.cropper-view-box{outline:1px solid rgba(255,255,255,.6) !important}", ""]);
// Exports
module.exports = exports;
